/* co-card-video.js
   Collection-grid cards whose featured image is a 360/photochromic video poster carry the
   .mp4 URL in that image's alt text (the same convention snippets/product-images.liquid
   uses on product pages). This attaches the source and plays it only while the card is on
   screen, so a long collection page does not download every clip at once.           */
(function () {
  'use strict';
  if (window.__coCardVideoInit) return;
  window.__coCardVideoInit = true;

  var SEL = 'video[data-co-card-video]';

  function attach(v) {
    if (v.getAttribute('src')) return;
    var src = v.getAttribute('data-src');
    if (!src) return;
    v.setAttribute('src', src);
    v.load();
  }

  function play(v) {
    attach(v);
    var p = v.play();
    if (p && p.catch) p.catch(function () { /* autoplay refused; poster stays visible */ });
  }

  function inView(v) {
    var r = v.getBoundingClientRect();
    if (!r.width || !r.height) return false;
    var h = window.innerHeight || document.documentElement.clientHeight;
    return r.top < h + 200 && r.bottom > -200;
  }

  /* Geometry sweep. IntersectionObserver is the efficient path, but it is not
     guaranteed to deliver a first callback in every environment, and cards that
     are already on screen should not wait for one. */
  function sweep() {
    var vids = document.querySelectorAll(SEL);
    for (var i = 0; i < vids.length; i++) {
      var v = vids[i];
      if (inView(v)) {
        if (v.paused) { play(v); }
        v.classList.add('is-playing');
      } else if (!v.paused) {
        v.pause();
      }
    }
  }

  function start() {
    var vids = document.querySelectorAll(SEL);
    if (!vids.length) return;

    var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    if (mq && mq.matches) return; // leave posters in place

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var v = entries[i].target;
          if (entries[i].isIntersecting) {
            play(v);
            v.classList.add('is-playing');
          } else if (!v.paused) {
            v.pause();
          }
        }
      }, { rootMargin: '200px 0px', threshold: 0.1 });
      for (var j = 0; j < vids.length; j++) io.observe(vids[j]);
    }

    sweep();                      // start anything already on screen
    setTimeout(sweep, 600);       // and again after layout settles

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      setTimeout(function () { ticking = false; sweep(); }, 250);
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
